var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurSerives2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9155 24.6704L30.0287 41.3145H21.4609L26.3379 24.6704H32.9155Z",
    fill: "#E53133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3945 10.8194H42.5292V4.38232H18.3945V10.8194Z",
    fill: "#E53133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3945 15.0569H42.5292V12.5754H18.3945V15.0569Z",
    fill: "#E53133"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5278 22.5175C29.4353 22.5175 28.5386 21.6429 28.5147 20.5504V20.5035C28.5147 19.388 29.4199 18.4904 30.5278 18.4904C31.6434 18.4904 32.5495 19.388 32.5495 20.5035C32.5495 20.8552 32.455 21.1907 32.2991 21.4786C31.9483 22.1028 31.2926 22.5175 30.5278 22.5175ZM18.3945 16.8213V28.1814H24.4416L25.3783 24.678C25.3783 24.242 25.6824 23.8903 26.08 23.8903H34.8666C35.2567 23.8903 35.5692 24.242 35.5692 24.678L36.6218 28.1814H42.5292V16.8213H18.3945Z",
    fill: "#E53133"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1518 53.9639C22.2488 53.9639 19.8848 51.6076 19.8848 48.6969C19.8848 45.7862 22.2488 43.429 25.1518 43.429C28.0625 43.429 30.4188 45.7862 30.4188 48.6969C30.4188 51.6076 28.0625 53.9639 25.1518 53.9639ZM18.3945 55.6177H31.9168V42.0955H18.3945V55.6177Z",
    fill: "#E53133"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1414 52.0086C23.5344 52.0086 22.1847 50.8462 21.8951 49.3168H20.4688C20.7651 51.6263 22.7467 53.4138 25.1414 53.4138C27.5377 53.4138 29.5202 51.6263 29.8165 49.3168H28.3876C28.0998 50.8462 26.75 52.0086 25.1414 52.0086ZM25.1414 45.3842C26.75 45.3842 28.0998 46.5389 28.3876 48.0692H29.8165C29.5202 45.7589 27.5377 43.9714 25.1414 43.9714C22.7467 43.9714 20.7651 45.7589 20.4688 48.0692H21.8951C22.1847 46.5389 23.5344 45.3842 25.1414 45.3842Z",
    fill: "#E53133"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurSerives2);
export default __webpack_public_path__ + "static/media/ourSerives2.41d3776c285b8cc9cf1b3a81b1b245b3.svg";
export { ForwardRef as ReactComponent };